import { render, staticRenderFns } from "./PieChartIcon.vue?vue&type=template&id=7c8221d9"
import script from "./PieChartIcon.vue?vue&type=script&lang=js"
export * from "./PieChartIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports